export function authHeader() {
    const token = localStorage.getItem('_token');
    if(token) {
        return {
            'Authorization': 'Bearer ' + token
        };
    }
    return '';
}